import { Text } from "@fluentui/react/lib/Text";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";

import { FilterToolTipContent } from "Components/Generic/FilterToolTipContent";
import { WithTranslator } from "Components/Generic/Translator";
import { IRendererProps } from "../IRendererProps";
import { TooltipDirection, TooltipCloseDelay, TooltipOpenDelay } from "../TooltipSettings";
import { UseTextRendererStyles } from "./UseTextRendererStyles";

export const TextRenderer = WithTranslator((props: IRendererProps): JSX.Element => {
  const { fieldName, item, styles } = props;
  const content = item?.[fieldName]?.toString();
  const styleSet = UseTextRendererStyles(styles);

  return (
    <TooltipHost
      closeDelay={TooltipCloseDelay}
      content={<FilterToolTipContent fieldName={fieldName} value={content} />}
      delay={TooltipOpenDelay}
      directionalHint={TooltipDirection}
      hostClassName={styleSet.host}
    >
      <div className={styleSet.root}>
        <Text>{content}</Text>
      </div>
    </TooltipHost>
  );
});
